import { a as r } from "./array-iteration.js";
import { a } from "./array-method-is-strict.js";
var o = r.forEach,
  t = a("forEach") ? [].forEach : function (r) {
    return o(this, r, arguments.length > 1 ? arguments[1] : void 0);
  };
export { t as a };